import React, { FC } from 'react';
import Banner from 'assets/images/top_team_banner.png';
import './style.scss';

type Props = {
  title: string;
};
const TopTeam: FC<Props> = ({ title }) => {
  return (
    <div className='top_team'>
      <h4 className='my-8'>{title} drumroll 🥁🥁🥁</h4>
      <img src={Banner} alt='banner' />
    </div>
  );
};

export default TopTeam;
